module.exports = __webpack_public_path__ + "img/beak.eff08956.svg";